import { TemplateService } from '../../../../../services/template.service';
import { Number2textThService } from '../../../../../services/number2text-th.service';
import { FormBuilder, Validators } from '@angular/forms';
import { combineLatest, of, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import Decimal from 'decimal.js-light';
var LineItemFormComponent = (function () {
    function LineItemFormComponent(formBuilder, template, number2text_th) {
        var _this = this;
        this.formBuilder = formBuilder;
        this.template = template;
        this.number2text_th = number2text_th;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.isSellerHeadOffice = false;
        this.isBuyerHeadOffice = false;
        this.isDisableAddDiscount = false;
        this.vats = [
            { label: 'Non-Vat', value: 'non-vat' },
            { label: 'Vat 0%', value: '0' },
            { label: 'Vat 7%', value: '7' }
        ];
        this.vatValue = {
            '0': 0,
            '7': 0.07
        };
        this.receiptVats = [
            { label: 'Empty', value: '' },
            { label: 'Non-Vat', value: 'non-vat' },
            { label: 'Vat 0%', value: '0' },
            { label: 'Vat 7%', value: '7' }
        ];
        this.validateNegative = function (control) {
            var isNegative = Boolean(!(_this.nonVATAmount.isNegative() || _this.vat0Amount.isNegative() || _this.vatAmount.isNegative()));
            return timer(300).pipe(switchMap(function () {
                return (isNegative) ? of(null) : new Promise(function (resolve) { return resolve({ vatAmountNegative: true }); });
            }));
        };
    }
    LineItemFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setDocumentTypes();
        this.createLineItemForm();
        this.lineItemForm.get('items').valueChanges.subscribe(function () { _this.calVAT(); });
        this.lineItemForm.get('endBillDiscountList').valueChanges.subscribe(function () { _this.calVAT(); });
        // any time the inner form changes update the parent of any change
        this.createSubscriptions();
    };
    LineItemFormComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    LineItemFormComponent.prototype.calVAT = function () {
        var vat = new Decimal(0);
        var vat7Amount = this.vatAmount.minus(this.vat0Amount);
        vat = vat.add(vat7Amount.mul(this.vatValue['7']));
        this.vat.setValue(vat.toDecimalPlaces(3).toDecimalPlaces(2).toString());
    };
    LineItemFormComponent.prototype.writeValue = function (value) {
        if (value) {
            this.lineItemForm.setValue(value);
            this.onChange(value);
            this.onTouched();
        }
    };
    LineItemFormComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    LineItemFormComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    // communicate the inner form validation to the parent form
    LineItemFormComponent.prototype.validate = function (_control) {
        var _this = this;
        return new Promise(function (resolve) {
            return _this.lineItemForm.valid ? resolve(null) : resolve({ lineItemForm: { valid: false } });
        });
    };
    LineItemFormComponent.prototype.createSubscriptions = function () {
        var _this = this;
        // Subscribe to valueChanges and statusChanges
        this.subscription = combineLatest([this.lineItemForm.valueChanges, this.lineItemForm.statusChanges]).subscribe(function () {
            var calculateValue = {
                amountText: _this.amountText,
                subTotal: _this.subTotal.toFixed(2),
                discountTotal: _this.discountTotal.toFixed(2),
                balance: _this.balance.toFixed(2),
                vat: _this.vat.value ? _this.vat.value : '',
                nonVATAmount: _this.nonVATAmount ? _this.nonVATAmount.toFixed(2) : '',
                vat0Amount: _this.vat0Amount ? _this.vat0Amount.toFixed(2) : '',
                vatAmount: _this.vatAmount ? _this.vatAmount.toFixed(2) : '',
                netTotal: _this.netTotal.toFixed(2),
                correctAmount: _this.correctAmount.toFixed(2),
                endOfBillDiscount: _this.endOfBillDiscount.toFixed(2),
                items: _this.items.value.map(function (item, index) { return ({
                    productID: item.productID,
                    description: item.description,
                    quantity: item.quantity,
                    unit: item.unit,
                    unitPrice: item.unitPrice,
                    discount: item.discount,
                    total: _this.getTotal(index).toFixed(2),
                    lineVAT: item.lineVAT,
                }); }),
            };
            _this.onChange(Object.assign({}, _this.lineItemForm.getRawValue(), calculateValue));
            _this.onTouched();
        });
    };
    LineItemFormComponent.prototype.setDocumentTypes = function () {
        var _this = this;
        this.documentTypes = this.template.getDropdown();
        if (this.isCreditNote || this.isDebitNote) {
            this.documentTypes.shift();
        }
        else {
            this.documentTypes = this.documentTypes.filter(function (element) { return element.value === _this.documentType; });
        }
    };
    Object.defineProperty(LineItemFormComponent.prototype, "isCreditNote", {
        get: function () {
            return this.documentType === 'credit_note';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "isDebitNote", {
        get: function () {
            return this.documentType === 'debit_note';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "isReceipt", {
        get: function () {
            return this.documentType === 'receipt';
        },
        enumerable: true,
        configurable: true
    });
    LineItemFormComponent.prototype.createLineItemForm = function () {
        this.lineItemForm = this.formBuilder.group({
            items: this.formBuilder.array([
                this.formBuilder.group({
                    productID: [null],
                    description: [null, Validators.required],
                    quantity: ['1', Validators.required],
                    unit: [null],
                    unitPrice: ['0.00', Validators.required],
                    discount: [null],
                    lineVAT: ["7"]
                })
            ]),
            endBillDiscountList: this.formBuilder.array([
                this.formBuilder.group({
                    endBillDiscount: [null],
                    typeDiscount: ['7']
                })
            ]),
            discountReason: [null],
            originalAmount: (this.isCreditNote || this.isDebitNote) ? [null, Validators.required] : [null],
            originalVAT: (this.isCreditNote || this.isDebitNote) ? [null, Validators.required] : [null],
            nonVATAmount: [null],
            vat0Amount: [null],
            vatAmount: [null],
            vat: [null],
            endOfBillDiscount: [null],
            percentVAT: ['7']
        }, { asyncValidator: this.validateNegative });
    };
    Object.defineProperty(LineItemFormComponent.prototype, "items", {
        get: function () {
            return this.lineItemForm.get('items');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "endBillDiscountList", {
        get: function () {
            return this.lineItemForm.get('endBillDiscountList');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "discountReason", {
        get: function () {
            return this.lineItemForm.get('discountReason');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "originalAmount", {
        get: function () {
            return this.lineItemForm.get('originalAmount');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "originalVAT", {
        get: function () {
            return this.lineItemForm.get('originalVAT');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "percentVAT", {
        get: function () {
            return this.lineItemForm.get('percentVAT');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "vat", {
        get: function () {
            return this.lineItemForm.get('vat');
        },
        enumerable: true,
        configurable: true
    });
    LineItemFormComponent.prototype.getProductID = function (index) {
        return this.items.controls[index].get('productID');
    };
    LineItemFormComponent.prototype.getDescription = function (index) {
        return this.items.controls[index].get('description');
    };
    LineItemFormComponent.prototype.getQuantity = function (index) {
        return this.items.controls[index].get('quantity');
    };
    LineItemFormComponent.prototype.getUnit = function (index) {
        return this.items.controls[index].get('unit');
    };
    LineItemFormComponent.prototype.getUnitPrice = function (index) {
        return this.items.controls[index].get('unitPrice');
    };
    LineItemFormComponent.prototype.getDiscount = function (index) {
        return this.items.controls[index].get('discount');
    };
    LineItemFormComponent.prototype.getLineVAT = function (index) {
        return this.items.controls[index].get('lineVAT');
    };
    LineItemFormComponent.prototype.getTypeDiscount = function (index) {
        return this.endBillDiscountList.controls[index].get('typeDiscount');
    };
    LineItemFormComponent.prototype.getEndBillDiscount = function (index) {
        return this.endBillDiscountList.controls[index].get('endBillDiscount');
    };
    LineItemFormComponent.prototype.getTotal = function (index) {
        var quantity = new Decimal(this.getQuantity(index).value || 0);
        var unitPrice = new Decimal(this.getUnitPrice(index).value || 0);
        var discount = new Decimal(this.getDiscount(index).value || 0);
        var total = quantity.mul(unitPrice).minus(discount);
        return total.toDecimalPlaces(2);
    };
    Object.defineProperty(LineItemFormComponent.prototype, "endOfBillDiscount", {
        get: function () {
            var endOfBillDiscount = new Decimal(0);
            for (var index = 0; index < this.endBillDiscountList.length; index++) {
                var discount = new Decimal(this.getEndBillDiscount(index).value || 0);
                endOfBillDiscount = endOfBillDiscount.add(discount);
            }
            return endOfBillDiscount.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "subTotal", {
        get: function () {
            var subTotal = new Decimal(0);
            for (var index = 0; index < this.items.length; index++) {
                var quantity = new Decimal(this.getQuantity(index).value || 0);
                var unitPrice = new Decimal(this.getUnitPrice(index).value || 0);
                subTotal = subTotal.add(quantity.mul(unitPrice));
            }
            return subTotal.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "vatAmount", {
        get: function () {
            var vatAmount = new Decimal(0);
            for (var index = 0; index < this.items.length; index++) {
                if (this.getLineVAT(index).value == '7') {
                    vatAmount = vatAmount.add(this.getTotal(index));
                }
            }
            for (var index = 0; index < this.endBillDiscountList.length; index++) {
                if (this.getTypeDiscount(index).value == '7') {
                    var discount = new Decimal(this.getEndBillDiscount(index).value || 0);
                    vatAmount = vatAmount.minus(discount);
                }
            }
            return vatAmount.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "nonVATAmount", {
        get: function () {
            var nonVATAmount = new Decimal(0);
            for (var index = 0; index < this.items.length; index++) {
                if (this.getLineVAT(index).value == 'non-vat') {
                    nonVATAmount = nonVATAmount.add(this.getTotal(index));
                }
            }
            for (var index = 0; index < this.endBillDiscountList.length; index++) {
                if (this.getTypeDiscount(index).value == 'non-vat') {
                    var discount = new Decimal(this.getEndBillDiscount(index).value || 0);
                    nonVATAmount = nonVATAmount.minus(discount);
                }
            }
            return nonVATAmount.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "vat0Amount", {
        get: function () {
            var vat0Amount = new Decimal(0);
            for (var index = 0; index < this.items.length; index++) {
                if (this.getLineVAT(index).value == '0') {
                    vat0Amount = vat0Amount.add(this.getTotal(index));
                }
            }
            for (var index = 0; index < this.endBillDiscountList.length; index++) {
                if (this.getTypeDiscount(index).value == '0') {
                    var discount = new Decimal(this.getEndBillDiscount(index).value || 0);
                    vat0Amount = vat0Amount.minus(discount);
                }
            }
            return vat0Amount.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "discountTotal", {
        get: function () {
            var discountTotal = new Decimal(0);
            for (var index = 0; index < this.items.length; index++) {
                var discount = new Decimal(this.getDiscount(index).value || 0);
                discountTotal = discountTotal.add(discount);
            }
            return discountTotal.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "balance", {
        get: function () {
            var balance = this.subTotal.minus(this.discountTotal).minus(this.endOfBillDiscount);
            return balance.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "netTotal", {
        get: function () {
            var vatValue = new Decimal(this.vat.value || 0);
            var netTotal = this.balance.add(vatValue);
            return netTotal.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "correctAmount", {
        get: function () {
            var correctAmount = new Decimal(0);
            var originalAmount = new Decimal(this.originalAmount.value || 0);
            if (this.isDebitNote) {
                correctAmount = originalAmount.add(this.balance);
            }
            else if (this.isCreditNote) {
                correctAmount = originalAmount.minus(this.balance);
            }
            return correctAmount.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "amountText", {
        get: function () {
            return this.number2text_th.currencyFormat_Baht(this.netTotal.toString());
        },
        enumerable: true,
        configurable: true
    });
    LineItemFormComponent.prototype.addItem = function () {
        this.items.push(this.formBuilder.group({
            productID: [null],
            description: [null, Validators.required],
            quantity: ['1', Validators.required],
            unit: [null],
            unitPrice: ['0.00', Validators.required],
            discount: [null],
            lineVAT: ["7"]
        }));
    };
    LineItemFormComponent.prototype.removeItem = function (index) {
        this.items.removeAt(index);
    };
    LineItemFormComponent.prototype.addEndBillDiscount = function () {
        this.endBillDiscountList.push(this.formBuilder.group({
            endBillDiscount: [null],
            typeDiscount: ['7']
        }));
        if (this.endBillDiscountList.length >= 3) {
            this.isDisableAddDiscount = true;
        }
    };
    LineItemFormComponent.prototype.removeEndBillDiscount = function (index) {
        this.endBillDiscountList.removeAt(index);
        if (this.endBillDiscountList.length < 3) {
            this.isDisableAddDiscount = false;
        }
    };
    return LineItemFormComponent;
}());
export { LineItemFormComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/line-item-form/line-item-form.component.ts.pre-build-optimizer.js